import { render } from "./DeclencheurRegisterOnSite.vue?vue&type=template&id=12b234ea"
import script from "./DeclencheurRegisterOnSite.vue?vue&type=script&lang=ts"
export * from "./DeclencheurRegisterOnSite.vue?vue&type=script&lang=ts"
script.render = render

export default script